import axios from "axios";
import Vue from "vue";
import objectUtils from "../../util/objectUtils";
import helper from "../../util/helper";

const getDefaultSelectedDiscountPackage = () => {
  return {
    saleStartDate: null,
    saleEndDate: null,
    salesChannelIds: [],
    enabled: true,
    freezeUsage: false,
    features: [],
    cabinClasses: [],
  };
};

export default {
  state: () => ({
    selectedDiscountPackage: getDefaultSelectedDiscountPackage(),
  }),

  mutations: {
    setSelectedDiscountPackage(state, discountPackage) {
      Vue.set(state, "selectedDiscountPackage", discountPackage);
    },
    setDefaultSelectedDiscountPackage(state) {
      Vue.set(state, "selectedDiscountPackage", getDefaultSelectedDiscountPackage());
    },
  },
  actions: {
    //TODO: load, update, create
    createDiscountPackage: (context, request) => {
      //TODO: Loader start
      return axios
        .post(context.getters.getMcServiceUrl + "/discount-packages/entity", request, {})
        .then((response) => {
          //TODO: Loader end
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    loadDiscountPackages: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/discount-packages/entity").then((response) => {
        return response.data;
      });
    },
    loadPublishedDiscountPackages: (context) => {
      //TODO: Loader start
      return axios.get(context.getters.getMcServiceUrl + "/discount-packages/entity/published").then((response) => {
        //TODO: Loader koyulacak
        return response.data;
      });
    },
    loadDiscountPackage: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/discount-packages/entity/" + request.id).then((response) => {
        return response.data;
      });
    },
    loadDiscountPackageHistory: (context, request) => {
      //TODO: Loader start
      return axios.post(context.getters.getMcServiceUrl + "/discount-packages/entity/history/search", request, {}).then((response) => {
        //TODO: Loader end
        return response.data;
      });
    },
    loadSelectedDiscountPackageHistory: (context, request) => {
      return axios.get(context.getters.getMcServiceUrl + "/discount-packages/history/" + request.id, {}).then((response) => {
        return response.data;
      });
    },
    deleteDiscountPackage: (context, discountPackage) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/discount-packages/entity/" + discountPackage.id)
        .then((response) => {
          let intents = [];
          intents.push(response.data);
          discountPackage.intents = intents;
          discountPackage.intentId = response.data.id;
          return discountPackage;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    deleteDraftDiscountPackage: (context, discountPackage) => {
      return axios
        .delete(context.getters.getMcServiceUrl + "/discount-packages/draft/" + discountPackage.intentId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          if (err.response.status === 400) {
            context.commit("setWarningModalContent", err.response.data.message);
            return "warning";
          }
        });
    },
    publishDiscountPackage: (context, discountPackage) => {
      return axios.get(context.getters.getMcServiceUrl + "/discount-packages/publish/" + discountPackage.intentId).then((response) => {
        if (response.data) {
          response.data.intentId = 0;
        }
        return response.data;
      });
    },
    rejectDiscountPackage: (context, discountPackage) => {
      return axios.get(context.getters.getMcServiceUrl + "/discount-packages/reject/" + discountPackage.intentId).then((response) => {
        if (discountPackage.intents[0].type === "DELETE_DISCOUNT_PACKAGE") {
          discountPackage.intents = null;
          discountPackage.intentId = 0;
        } else if (discountPackage.intents[0].type === "CREATE_DISCOUNT_PACKAGE") {
          discountPackage.intents[0].status = "DRAFT";
        } else if (discountPackage.intents[0].type === "UPDATE_DISCOUNT_PACKAGE") {
          discountPackage.intents[0].status = "DRAFT";
        }
        return response.data;
      });
    },
    sendToApprovalDiscountPackage: (context, discountPackage) => {
      return axios.get(context.getters.getMcServiceUrl + "/discount-packages/sendToApproval/" + discountPackage.intentId).then((response) => {
        if (discountPackage.intents[0].type === "CREATE_DISCOUNT_PACKAGE") {
          discountPackage.intents[0].status = "WAITING_APPROVAL";
        } else if (discountPackage.intents[0].type === "UPDATE_DISCOUNT_PACKAGE") {
          discountPackage.intents[0].status = "WAITING_APPROVAL";
        }
        return response.data;
      });
    },

    recallDiscountPackage: (context, discountPackage) => {
      return axios.get(context.getters.getMcServiceUrl + "/discount-packages/recall/" + discountPackage.intentId).then((response) => {
        helper.recallOrRejectEntity(discountPackage, "DISCOUNT_PACKAGE");
        return response.data;
      });
    },
    cancelDiscountPackage: (context, discountPackage) => {
      return axios.get(context.getters.getMcServiceUrl + "/discount-packages/cancel/" + discountPackage.intentId).then((response) => {
        return response.data;
      });
    },
    loadSelectedDiscountPackagePurchasesHistory: (context, request) => {
      return axios
        .get(context.getters.getCrsServiceUrl + "/discount-package-purchases/" + request.id + "/history", { headers: { "sales-channel-id": 3 } })
        .then((response) => {
          return response.data;
        });
    },
    loadDiscountPackagesByUserId: (context, request) => {
      return axios
        .get(context.getters.getCrsServiceUrl + "/purchase-histories/discount-packages/" + request.userId)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },
  getters: {
    getSelectedDiscountPackage: (state) => {
      return state.selectedDiscountPackage;
    },
  },
};
